import styled, { css } from "styled-components";
import { activeColor, color, elevation, hoverColor, onHover, snap, typeStyle, units, variant } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
export const TRANSITION_DURATION = 250;
export const ToastMessage = styled.div `
  position: relative;
  overflow: hidden;
  max-height: ${snap(200)};
  background-color: ${color("hint")};
  border-radius: ${units(3)};
  box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.25);
  z-index: ${elevation("toast")};
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};

  [data-whatinput="mouse"] &,
  [data-whatinput="touch"] & {
    outline: none;
  }

  ${({ placement }) => variant("toastType", {
    portal: css `
        position: absolute;
        ${placement === "bottom" ? `bottom: ${units(1)};` : `top: ${units(1)};`}
        left: ${units(1)};
        right: ${units(1)};
        padding: ${units(1.5)} ${units(2)} ${units(2)} ${units(2)};
      `,
    default: css `
        position: fixed;
        ${placement === "bottom" ? `bottom: ${units(3)};` : `top: ${units(3)};`}
        left: 50%;
        margin-right: -50%;
        padding: ${units(1.5)} ${units(2)} ${units(2)};
      `
})};

  transition: all ${TRANSITION_DURATION}ms ease-in-out;

  ${(props) => css `
    ${variant("transitionState", {
    entering: css `
        opacity: 0;
        transform: ${props.toastType === "portal" ? `translateY(-4px)` : `translateY(-4px) translateX(-50%)`};
      `,
    entered: css `
        opacity: 1;
        transform: ${props.toastType === "portal" ? `translateY(0)` : `translateY(0) translateX(-50%)`};
      `,
    exiting: css `
        opacity: 0;
        transform: ${props.toastType === "portal" ? `translateY(-4px)` : `translateY(-4px) translateX(-50%)`};
      `,
    exited: css `
        opacity: 0;
        transform: ${props.toastType === "portal" ? `translateY(-4px)` : `translateY(-4px) translateX(-50%)`};
      `
})};
  `}

  a {
    color: ${color("typeBody")};
    text-decoration: none;

    ${onHover(css `
      color: ${hoverColor("contrast")};
      text-decoration: underline;
    `)}

    &:active {
      color: ${activeColor("contrast")};
      text-decoration: underline;
    }
  }
`;
export const MessageContentWrapper = styled.div `
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 2px;
  padding-right: ${units(3.5)};
  padding-bottom: 0;
  padding-left: ${units(4.5)};
  display: flex;
  align-items: flex-start;
`;
export const IconWrapper = styled.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: ${color("base")};
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;

  svg {
    height: ${units(3)};
    width: ${units(3)};
    max-width: ${units(3)};
  }
`;
export const CustomIcon = styled.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: ${color("container")};
  background-color: ${color("base")};
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;

  height: ${units(3.5)};
  width: ${units(3.5)};
  max-width: ${units(3.5)};

  svg {
    height: unset;
    width: unset;
  }
`;
export const Title = styled.strong `
  ${typeStyle("bodyS")};
  font-weight: bold;
  margin-right: ${units(0.5)};
`;
export const Content = styled.div `
  ${typeStyle("bodyS")};
`;
export const DismissButton = styled(NakedButton) `
  position: absolute;
  top: ${({ toastType }) => (toastType === "portal" ? units(0.5) : units(0.5))};
  right: 2px;
  padding: 0;
  width: ${units(2)};
  height: ${units(2)};
  border-radius: 50%;

  svg {
    color: ${color("base")};
  }

  ${onHover(css `
    svg {
      color: ${hoverColor("base")};
    }
  `)}

  &:active svg {
    color: ${activeColor("base")};
  }
`;
